<template>
    <nav class="conversation-navigation" aria-label="Conversation messages">
        <div class="conversation-navigation-items">
            <v-btn
                v-for="(message, index) in messages"
                :key="message.id"
                class="conversation-navigation-message"
                :class="{ active: message.id === activeMessageId }"
                icon
                variant="plain"
                :aria-label="`Jump to ${message.role === 'user' ? 'user' : message.role === 'system' ? 'system' : 'agent'} message ${index + 1}`"
                :aria-current="message.id === activeMessageId ? 'step' : undefined"
                @click="$emit('select', message.id)">
                <v-icon :icon="message.id === activeMessageId ? 'fa-solid fa-square' : 'fa-regular fa-square'" />
                <v-tooltip :disabled="$vuetify.display.xs || $vuetify.display.platform.touch" activator="parent" location="start">
                    {{ message.text || message.error || message.status || `${message.role === 'user' ? 'User message' : 'Agent response'} ${index + 1}` }}
                </v-tooltip>
            </v-btn>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'ConversationNavigation',
    props: {
        messages: { type: Array, default: () => [] },
        activeMessageId: { type: Number, default: null }
    },
    emits: ['select'],
    watch: {
        activeMessageId() {
            this.$nextTick(() => {
                const current = this.$el.querySelector('[aria-current="step"]')
                if (!current) return
                const rail = this.$el
                const top = current.getBoundingClientRect().top - rail.getBoundingClientRect().top + rail.scrollTop
                if (top < rail.scrollTop) rail.scrollTop = top
                else if (top + current.offsetHeight > rail.scrollTop + rail.clientHeight) {
                    rail.scrollTop = top + current.offsetHeight - rail.clientHeight
                }
            })
        }
    }
}
</script>

<style scoped>
.conversation-navigation {
    position: relative;
    flex: 0 0 var(--conversation-rail-width);
    min-height: 0;
    overflow-y: auto;
    scrollbar-width: none;
    padding-block: 8px;
}

.conversation-navigation::-webkit-scrollbar {
    display: none;
}

.conversation-navigation-items {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.conversation-navigation-message {
    flex: none;
    width: 54px;
    min-width: 54px;
    height: 54px;
    padding: 0;
    color: rgb(var(--v-theme-secondary));
}

.conversation-navigation-message .v-icon {
    font-size: 1rem;
    transition: transform var(--agent-motion-duration, 300ms) var(--agent-motion-easing, ease-out);
}

.conversation-navigation-message.active .v-icon {
    transform: scale(1.12);
}

.conversation-navigation-message.active {
    color: rgb(var(--v-theme-primary));
}

@media (max-width: 1600px) {
    .conversation-navigation-message {
        width: 50px;
        min-width: 50px;
        height: 50px;
    }
}

@media (max-width: 1200px) {
    .conversation-navigation-message {
        width: 40px;
        min-width: 40px;
        height: 40px;
    }
}
</style>
